export default __webpack_public_path__ + "_/shared_modules/baui-ui/components/LoanAmountFilter/images/plus-sky-900-6c9656877efac3588c8c3f14356398c6.svg";